export const UserManagementConstants = {
    statuses: [
        { enabled: true, label: 'Active' },
        { enabled: false, label: 'Inactive' },
    ],
};
